export default __webpack_public_path__ + "static/media/made_with_str_mix.6ca88c65.png";